import type { CssGeneratorContext } from '../css-generator.model';

export const styles = ({ dt }: CssGeneratorContext) => `
  .custom-tooltip {
    position: relative;
    display: inline;
    & .tooltip-container {
      position: relative;
      display: inline-flex;
      align-items: center;
      cursor: pointer;
    }

    & .tooltip-icon {
      color: ${dt('surface.400')};
      font-size: 1.125rem;
      transition: color ${dt('transition.duration')};
      line-height: 1;
    }

    & .tooltip-icon:hover,
    & .tooltip-icon.active {
      color: ${dt('surface.600')};
    }

    & .tooltip-content {
      cursor: pointer;
      position: fixed;
      background-color: ${dt('tooltip.background')};
      color: ${dt('tooltip.color')};
      padding: ${dt('tooltip.padding')};
      border-radius: ${dt('tooltip.border.radius')};
      font-size: 0.75rem;
      opacity: 0;
      visibility: hidden;
      transition:
        opacity .3s,
        visibility .3s;
      z-index: 1000;
      min-width: 28.125rem;
      max-width: 28.125rem;
      box-shadow: ${dt('tooltip.shadow')};
      word-wrap: break-word;
      white-space: normal;
    }

    & .tooltip-position-bottom-left {
      transform: translate(-0.9375rem, 1.875rem);
    }

    & .tooltip-position-bottom-right {
      transform: translate(-26.0625rem, 1.875rem);
    }

    & .tooltip-position-left {
      transform: translate(1.875rem, -0.75rem);
    }

    & .tooltip-position-right {
      transform: translate(-28.875rem, -0.688rem);
    }

    & .tooltip-content span {
      display: block;
      text-align: left;
      line-height: 1.6;
    }

    & .tooltip-content::before {
      content: '';
      position: absolute;
      width: 0;
      height: 0;
    }

    & .tooltip-position-bottom-left::before {
      top: calc(-1 * ${dt('tooltip.gutter')});
      left: 1rem;
      border-left: ${dt('tooltip.gutter')} solid transparent;
      border-right: ${dt('tooltip.gutter')} solid transparent;
      border-bottom: ${dt('tooltip.gutter')} solid ${dt('tooltip.background')};
    }

    & .tooltip-position-bottom-right::before {
      top: calc(-1 * ${dt('tooltip.gutter')});
      right: 1rem;
      border-left: ${dt('tooltip.gutter')} solid transparent;
      border-right: ${dt('tooltip.gutter')} solid transparent;
      border-bottom: ${dt('tooltip.gutter')} solid ${dt('tooltip.background')};
    }

    & .tooltip-position-left::before {
      top: 0.8125rem;
      left: calc(-1 * ${dt('tooltip.gutter')});
      border-top: ${dt('tooltip.gutter')} solid transparent;
      border-bottom: ${dt('tooltip.gutter')} solid transparent;
      border-right: ${dt('tooltip.gutter')} solid ${dt('tooltip.background')};
    }

    & .tooltip-position-right::before {
      top: 0.75rem;
      right: calc(-1 * ${dt('tooltip.gutter')});
      border-top: ${dt('tooltip.gutter')} solid transparent;
      border-bottom: ${dt('tooltip.gutter')} solid transparent;
      border-left: ${dt('tooltip.gutter')} solid ${dt('tooltip.background')};
    }

    & .accept-button {
      & .p-button {
        background-color: transparent;
        border: 1px solid ${dt('primary.contrast.color')};
        color: ${dt('primary.contrast.color')};
        border-radius: ${dt('border.radius.none')};
        font-size: 0.75rem;
        padding: ${dt('form.field.padding.y')} ${dt('form.field.padding.x')};
        font-weight: 600;
      }

      & .p-button:enabled:hover {
        background-color: ${dt('primary.contrast.color')};
        border-color: ${dt('primary.contrast.color')};
        color: ${dt('tooltip.background')};
      }
    }

    & .tooltip-content.visible {
      opacity: 1;
      visibility: visible;
    }

    & .custom-close-button {
      & p-button,
      & .p-button {
        padding: 0;
        height: 1.25rem;
        width: 1.25rem;
        background-color: transparent;
        background: transparent;
        border: none;
      }

      & .p-button:hover,
      & .p-button-text:hover,
      & .p-button-text:not(:disabled):hover {
        background-color: transparent;
        background: transparent;
        border: none;
      }

      & .p-button-text {
        color: ${dt('primary.contrast.color')};
      }
    }
  }

  .p-tooltip-text {
    font-size: 0.75rem;
    line-height: 1.6;
    text-align: left;
  }
`;
